export var TemplateBackgroundsEnum;
(function (TemplateBackgroundsEnum) {
    TemplateBackgroundsEnum["EMPTY_BG"] = "EMPTY_BG";
    TemplateBackgroundsEnum["STANDARD_BG_FIRST"] = "STANDARD_BG_FIRST";
    TemplateBackgroundsEnum["STANDARD_BG_SECOND"] = "STANDARD_BG_SECOND";
    TemplateBackgroundsEnum["CUSTOM_BG"] = "CUSTOM_BG";
})(TemplateBackgroundsEnum || (TemplateBackgroundsEnum = {}));
